import { Box, Flex, LogoDot, Stack } from 'design-system';
import { SidebarItem } from 'layout/components/sidebar/sidebar-item';
import { useSidebarItems } from 'layout/components/sidebar/utils/sidebar-items';
import { useAppSelector } from 'redux/hooks';

interface ISidebar {
  // 'drawer' renders inside the mobile overlay: always expanded, height comes
  // from the drawer body instead of the viewport
  variant?: 'aside' | 'drawer';
}

export const Sidebar = ({ variant = 'aside' }: ISidebar) => {
  const sidebarItems = useSidebarItems();
  const isExpanded = useAppSelector((state) => state.sidebar.isOpen);
  const isSidebarOpen = variant === 'drawer' ? true : isExpanded;

  return (
    <Box
      h={variant === 'drawer' ? 'full' : '100vh'}
      bg='white'
      borderRight='1px'
      borderColor='gray.200'
      overflowY='auto'
      overflowX='hidden'
      css={{
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#E2E8F0',
          borderRadius: '2px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#CBD5E0',
        },
      }}>
      <Flex
        align={'center'}
        justify='center'
        h='68px'
        borderBottom={'1px solid'}
        borderColor='gray.200'
        bg='white'
        position='sticky'
        top={0}
        zIndex={10}
        px={isSidebarOpen ? 'md' : 'xs'}>
        <LogoDot />
      </Flex>

      <Stack spacing={'xs'} p={isSidebarOpen ? 'md' : 'sm'} pb='xl'>
        {sidebarItems.map((item, index) => (
          <SidebarItem item={item} isCollapsed={!isSidebarOpen} key={index} />
        ))}
      </Stack>
    </Box>
  );
};
